module.exports = __webpack_public_path__ + "media/images/filter-close@2x-8835c956ce644bcc412a303530e6e5c1.png";